export default {"src":"/_next/static/media/stepSuccesfullIcon.b0643efa.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};